export const Rights = [
    "WEB_MODULE_NOTICE_TIME_WRITE"
]
